<template>
    <div class="bracket">
      <div :class="heroContainerStyle" v-resize="checkLandscape">
        <video playsinline autoplay muted loop
        :poster="heroPoster"
        :class="heroStyle"
        :src="heroMovie"
        >
        </video>
        <HeroContent />
      </div>
    </div>
</template>

<script>
import HeroContent from '@/components/HeroContent.vue';

// const path = '@/assets/img/hero/';

// Import media files (landscape)
const heroMovieWide = require('@/assets/img/hero/mp4s/Heroimage-720p.mp4');
const heroPosterWide = require('@/assets/img/hero/Heroimage720pPoster.jpg');

// Import media files (portrait)
const heroMoviePortrait = require('@/assets/img/hero/mp4s/Heroimage-profile.mp4');
const heroPosterPortrait = require('@/assets/img/hero/heroMobile.jpg');

export default {
  components: {
    HeroContent,
  },
  data() {
    return {
      // When finished, get rid of everything that isn't 'heroimage'
      isLandscape: false,
      // heroimage: 'heroMobile.jpg',
      // herogif: 'heroimage.gif',
      // heromobile: 'mp4s/Heroimage-profile.mp4',
      // mobilePoster: 'heroMobile.jpg',
      // heroMovieWide: 'mp4s/Heroimage-720p.mp4',
      heroMovie: '',
      heroPoster: '',
      heroStyle: '',
      heroContainerStyle: '',
      heroMovieWide,
      heroPosterWide,
      heroMoviePortrait,
      heroPosterPortrait,
    };
  },
  computed: {
    // heroMovie: () => 'mp4s/Heroimage-720p.mp4',
    // foo: () => this.oh2,
  //   // isLandscape() {
  //   //   return window.innerWidth > window.innerHeight;
  //   // },
  //   width() {
  //     return window.innerWidth;
  //   },
  },
  methods: {
    // getResponsiveBanner() {
    //   if (window.innerWidth >= 600) {
    //     this.heroimage = 'heroimage.gif';
    //   } else {
    //     this.heroimage = 'heroMobile.jpg';
    //   }
    // },
    checkLandscape() {
      this.isLandscape = window.innerWidth > window.innerHeight;
      // console.log(`isLandscape: ${this.isLandscape}`);
      this.assignMedia();
      this.assignStyle();
    },
    assignMedia() {
      if (this.isLandscape) {
        this.heroMovie = heroMovieWide;
        this.heroPoster = heroPosterWide;
      } else {
        this.heroMovie = heroMoviePortrait;
        this.heroPoster = heroPosterPortrait;
      }
      // console.log(`Current movie: ${this.heroMovie}`);
    },
    assignStyle() {
      if (this.isLandscape) {
        this.heroStyle = 'hero';
        this.heroContainerStyle = 'hero-container';
      } else {
        this.heroStyle = 'hero hero-m';
        this.heroContainerStyle = 'hero-container hero-container-m';
      }
    },
    // isLandscape() {
    // },
  },
  mounted() {
    // this.width = window.innerWidth;
    // this.getResponsiveBanner();
    this.checkLandscape();
  },

};
</script>

<style scoped>
  .bracket {
    min-height: 100vh;
    min-width: 100vw;
    background-color: #2f4858;
    /* background-color: rgba(78, 134, 168, 0.99); */
    /* background-color: rgba(78, 134, 168, 0.99)/ */
    overflow: hidden;
  }

  .hero {
      display: block;
      min-height: 100vh;
      min-width: 100vw;
      /* width: 100vw; */
      /* max-width: 100vw; */
      /* height: 300px; */
      z-index: -10;
      /* filter: opacity(15%); */
      /* opacity: .15; */
      opacity: .1;
      /* position: absolute; */
      object-fit: cover;
      /* margin-bottom: -10px; */
      /* margin-right: -10px; */
  }

  .hero.hero-m {
    /* transform: translate(-10%); */
    object-position: 50% 50%;
  }

  .hero-container {
    min-height: 100vh;
    /* width: 100%; */
    padding: 0;
    overflow: hidden;
    /* background-image: linear-gradient(to right, blue , yellow); */
    /* background-image: linear-gradient(to left, rgb(47, 72, 88, .95) 55%,
    85%, rgb(239, 229, 212, .5)); */
    z-index: 1;
  }

  /* .hero-container.hero-container-m { */
    /* min-height: 100vh; */
    /* padding: 0; */
    /* overflow: hidden; */
    /* background-image: linear-gradient(to right, blue , yellow); */
    /* background-image: linear-gradient(to left, rgba(78, 134, 168, 0.99) 75%,
    95%, rgb(239, 229, 212, .5)); */
    /* z-index: 1; */
    /* object-fit: cover; */
  /* } */

  @media only screen and (max-width: 400px) {
    .hero.hero-m {
      transform: translate(-20%);
    }
  }

  @media only screen and (min-width: 400px) and (max-width: 450px) {
    .hero.hero-m {
      transform: translate(-15%);
    }
  }
    @media only screen and (min-width: 600px) and (max-width: 1025px) {
    .hero.hero-m {
      transform: scale(1.1);
    }
  }
    /* For phones in landscape: */
    @media only screen and (min-width: 600px) and (max-height: 450px) {
    .hero {
      width: 900px;
      /* transform: translate(0%, -10%); */
      /* transform: scale(.8); */
      /* display: none; */
    }
  }

  @media only screen and (min-width: 1200px) {
    .hero-container {
      background-image: linear-gradient(to left, rgb(47, 72, 88, .95) 45%,
      75%, rgb(239, 229, 212, .5));
    }
  }

</style>
